export default function Footer({ settings }) {
  return (
    <footer>
      <div className="container">
        <div className="brand" style={{ display: "inline-flex" }}>
          <div className="mark">
            <i className="fa-solid fa-seedling" />
          </div>
          <div>
            <b>Green World Nature Pride</b>
            <span>Healthcare</span>
          </div>
        </div>
        <p>Natural Supplements for a Healthy Living</p>
        <div className="socials">
          <a href={`https://wa.me/${settings.whatsapp}`} target="_blank" rel="noopener">
            <i className="fa-brands fa-whatsapp" />
          </a>
          <a href={settings.facebook} target="_blank" rel="noopener">
            <i className="fa-brands fa-facebook-f" />
          </a>
          <a href="#" target="_blank" rel="noopener">
            <i className="fa-brands fa-instagram" />
          </a>
          <a href="#" target="_blank" rel="noopener">
            <i className="fa-brands fa-tiktok" />
          </a>
        </div>
        <p>&copy; 2025 Green World Nature Pride Healthcare. All rights reserved.</p>
        <p style={{ fontSize: ".72rem", marginTop: "10px", opacity: 0.7 }}>
          Supplements are not intended to diagnose, treat, cure or prevent any disease. Consult a healthcare
          professional.
        </p>
      </div>
    </footer>
  );
}
